import React, { RefObject, useEffect, useRef, useState } from 'react';

import { Tooltip } from '@xsolla/ui-core';

import useWindowDimensions from '../../../hooks/useWindowDimensions';

type Props = {
  text: string;
  tooltipText?: string;
};

const AutoTooltipedText = ({ text, tooltipText }: Props): JSX.Element => {
  const [isTooltipShowing, setTooltipShowing] = useState<boolean | void>();

  const { width } = useWindowDimensions();

  const itemRef: RefObject<HTMLSpanElement> = useRef(null);

  useEffect(() => {
    const visibleTextWidth = itemRef?.current?.parentElement?.clientWidth;
    const originTextWidth = itemRef?.current?.getBoundingClientRect().width;

    if (!visibleTextWidth || !originTextWidth) {
      return;
    }

    const isTooltipNeeded = visibleTextWidth + 1 < originTextWidth;

    setTooltipShowing(isTooltipNeeded);
  }, [width, itemRef?.current?.parentElement?.clientWidth]);

  if (isTooltipShowing) {
    return (
      <span ref={itemRef}>
        <Tooltip content={tooltipText || text}>
          <span>{text}</span>
        </Tooltip>
      </span>
    );
  }

  return (
    <span ref={itemRef}>
      <span>{text}</span>
    </span>
  );
};

export default AutoTooltipedText;
